import styled, { css } from 'styled-components';
import { colorAliases, colors } from '../../variables/colors.js';
import { deviceWidths } from '../../variables/widths.js';
import { fonts } from '../../variables/fonts.js';
import { owlImage, tripAdvisorRatingImgBackground, tripAdvisorRatingImgFilling } from '../../images/ratings.js';

var TripAdvisorRating = styled.div.withConfig({
  displayName: "style__TripAdvisorRating",
  componentId: "sc-xy2eaq-0"
})(["align-items:center;display:inline-flex;flex-direction:column;text-align:center;@media (max-width:", "){", "}", ""], deviceWidths.tabletMax, function (props) {
  return props.responsive && css(["flex-direction:row;&::before{background:url(", ") top left no-repeat;background-size:contain;bottom:0;content:'';display:inline-block;font-size:14px;height:13px;text-align:right;width:25px;}"], owlImage);
}, function (props) {
  return props.clickable && css(["cursor:pointer;"]);
});
var Header = styled.span.withConfig({
  displayName: "style__Header",
  componentId: "sc-xy2eaq-1"
})(["display:block;font-family:", ";font-size:16px;padding-bottom:8px;text-transform:uppercase;"], fonts.bold);
var Grade = styled.span.withConfig({
  displayName: "style__Grade",
  componentId: "sc-xy2eaq-2"
})(["color:", ";font-family:", ";font-size:34px;@media (max-width:", "){", "}@media (min-width:", "){", "}"], colorAliases.text, fonts.regular, deviceWidths.tabletMax, function (props) {
  return props.responsive && css(["font-size:14px;"]);
}, deviceWidths.tablet, function (props) {
  return props.hideRatingDesktop && css(["display:none;"]);
});
var ImageContainer = styled.span.withConfig({
  displayName: "style__ImageContainer",
  componentId: "sc-xy2eaq-3"
})(["display:inline-block;"]);
var RatingImageWrapper = styled.span.withConfig({
  displayName: "style__RatingImageWrapper",
  componentId: "sc-xy2eaq-4"
})(["display:flex;background-repeat:no-repeat;background-size:contain;overflow:visible;height:20px;width:119px;background-image:url(", ");", " @media (max-width:", "){", "}"], tripAdvisorRatingImgBackground, function (props) {
  return props.removeOwlPixels < 0 && css(["background-position:", "px 0;"], props.removeOwlPixels);
}, deviceWidths.tabletMax, function (props) {
  return props.responsive && css(["display:none;"]);
});
var RatingImage = styled.span.withConfig({
  displayName: "style__RatingImage",
  componentId: "sc-xy2eaq-5"
})(["background-size:contain;overflow:visible;height:20px;width:119px;background-image:url(", ");position:absolute;", " ", ""], tripAdvisorRatingImgFilling, function (props) {
  return props.ratingInPixels && css(["clip:rect(0px,", "px,20px,0px);"], props.ratingInPixels);
}, function (props) {
  return props.removeOwlPixels < 0 && css(["background-position:", "px 0;"], props.removeOwlPixels);
});
var Label = styled.span.withConfig({
  displayName: "style__Label",
  componentId: "sc-xy2eaq-6"
})(["color:", ";display:block;font-size:14px;text-align:center;&::after{font-size:10px;margin-left:3px;}@media (max-width:", "){", "}"], colors.mediumGray, deviceWidths.tabletMax, function (props) {
  return props.responsive && css(["display:none;"]);
});
var LinkContainer = styled.span.withConfig({
  displayName: "style__LinkContainer",
  componentId: "sc-xy2eaq-7"
})([".sg-trip-advisor-rating-link{font-size:14px;margin:0 auto;svg{height:10px;width:10px;}}@media (max-width:", "){", "}"], deviceWidths.tabletMax, function (props) {
  return props.responsive && css(["display:none;"]);
});
var Subtext = styled.span.withConfig({
  displayName: "style__Subtext",
  componentId: "sc-xy2eaq-8"
})(["@media (max-width:", "){", "}"], deviceWidths.tabletMax, function (props) {
  return props.responsive && css(["display:none;"]);
});

export { Grade, Header, ImageContainer, Label, LinkContainer, RatingImage, RatingImageWrapper, Subtext, TripAdvisorRating };
//# sourceMappingURL=style.js.map
